import React, { Component } from 'react';
import { translate } from '../Services/translation';
import { connect } from 'react-redux';
import { displayLoader, setAuthorizationHybris, setActiveBahagErrorModal, showConfirmLogin, showBahagSignIn, showBahagSignUp, showBahagForgetPassword,  createCustomer, setSignUpForm } from '../actions/Bahag.action';
import { setCookie } from "../Components/AB-test-read-more";
import BahagTerms from './BahagTerms';
import citiesData from './GermanCities.json';

class BahagSignUp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: {
                deviceId: "CTEK",
                firstname: "",
                lastname: "",
                address: "",
                zipCode: "",
                city: "",
                phone: "",
                email: "",
                password: "",
                confirmPassword: "",
                houseNumber: "",
                germanCities: []
            },
            errors: {},
            errorMessage: "",
            emailErrorMessage: "",
            isShowWrongMessage: false,
            isShowPasswordForm: false,
            isShowSignupForm: true,
            isShowConfirm: false,
            isShowPasswordErrorMessage: false,
            isShowErrorRegister: false,
            isShowValidationErrorMessage: false,
            isShowEmailErrorMessage: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.handleCreateAccount = this.handleCreateAccount.bind(this);
        this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
        this.handleInputPhone = this.handleInputPhone.bind(this);
        this.updateFormData = this.updateFormData.bind(this);
        this.handleInputEmail = this.handleInputEmail.bind(this);
        this.handleUpdatePasswordChange = this.handleUpdatePasswordChange.bind(this);
        this.handleEditInfo = this.handleEditInfo.bind(this);
    }

    componentDidMount() {
        const { signUpForm } = this.props;
        const germanCities = citiesData.map(city => city.name.toLowerCase());
        this.setState({ germanCities });

        this.setState({
            formData: signUpForm
        });
    }

    renderSignup() {
        const { errors, formData } = this.state;
        return (
            <>
                <h3 id="bahag-signin" className="checkout__section-title">{translate('checkout.bahag.signin.header')}</h3>
                <div className="germany-section__signup-container">
                    <div className="germany-section__signup-container--header-container">
                        <span className="germany-section__signup-container--header-container--icon"></span>
                        <p className="germany-section__signup-container--header-container--header">{translate("checkout.bahag.signup.title")}</p>
                        <p className="germany-section__signup-container--header-container--subheader">
                            {translate("checkout.bahag.signup.description")}
                        </p>

                        {this.state.isShowValidationErrorMessage &&
                            <div className="germany-section__signup-container--header-container--error-message">
                                <p>{this.state.errorMessage}</p>
                            </div>
                        }
                    </div>
                    <form>
                        <div className="germany-section__signup-container__name-container germany-section__signup-container__input">
                            <div className="germany-section--input-container">
                                <input
                                    type="text"
                                    name="firstname"
                                    placeholder={translate('bahag.signup.placeholder.first.name')}
                                    value={formData.firstname}
                                    onChange={this.handleInputChange}
                                    required
                                />
                                {errors.firstname && <span className="germany-section__signup-container__input--error-message">{errors.firstname}</span>}
                            </div>
                            <div className="germany-section--input-container">
                                <input
                                    type="text"
                                    name="lastname"
                                    placeholder={translate('bahag.signup.placeholder.last.name')}
                                    value={formData.lastname}
                                    onChange={this.handleInputChange}
                                    required
                                />
                                {errors.lastname && <span className="germany-section__signup-container__input--error-message">{errors.lastname}</span>}
                            </div>
                        </div>

                        <p className="germany-section__signup-container--title">{translate('bahag.signup.address.title')}</p>

                        <div className="germany-section__signup-container__input germany-section__signup-container--address">
                            <div className="germany-section__signup-container--inner-address-house">
                                <div className="germany-section--input-container germany-section__signup-container--inner-address-house__address">
                                    <input
                                        type="text"
                                        name="address"
                                        placeholder={translate('bahag.signup.placeholder.address')}
                                        value={formData.address}
                                        onChange={this.handleInputChange}
                                        required
                                    />
                                    {errors.address && <span className="germany-section__signup-container__input--error-message">{errors.address}</span>}
                                </div>

                                <div className="germany-section--input-container germany-section__signup-container--inner-address-house__number">
                                    <input
                                        type="text"
                                        name="houseNumber"
                                        placeholder={translate('bahag.signup.placeholder.house.number')}
                                        value={formData.houseNumber}
                                        onChange={this.handleInputChange}
                                        required
                                        maxLength="5"
                                    />
                                    {errors.houseNumber && <span className="germany-section__signup-container__input--error-message">{errors.houseNumber}</span>}
                                </div>
                            </div>
                            <div className="germany-section__signup-container__input germany-section__signup-container--inner-address">
                                <div className="germany-section--input-container">
                                    <input
                                        type="text"
                                        name="zipCode"
                                        placeholder={translate('bahag.signup.placeholder.zip.code')}
                                        value={formData.zipCode}
                                        onChange={this.handleInputChange}
                                        required
                                    />
                                    {errors.zipCode && <span className="germany-section__signup-container__input--error-message">{errors.zipCode}</span>}
                                </div>
                                <div className="germany-section--input-container">
                                    <input
                                        type="text"
                                        name="city"
                                        placeholder={translate('bahag.signup.placeholder.city')}
                                        value={formData.city}
                                        onChange={this.handleInputChange}
                                        required
                                    />
                                    {errors.city && <span className="germany-section__signup-container__input--error-message">{errors.city}</span>}
                                </div>
                            </div>

                            <p className="germany-section__signup-container--title germany-section__signup-container--completeTitle">
                                {translate('bahag.signup.complete.with.title')}
                            </p>

                            <div className="germany-section__signup-container__input germany-section__signup-container--complete">
                                <div className="germany-section--input-container">
                                    <input
                                        type="phone"
                                        name="phone"
                                        placeholder={translate('bahag.signup.placeholder.phone')}
                                        value={formData.phone}
                                        onChange={this.handleInputPhone}
                                        required
                                    />

                                    {errors.phone && <span className="germany-section__signup-container__input--error-message">{errors.phone}</span>}
                                </div>
                                <div className="germany-section--input-container">
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder={translate('bahag.signup.placeholder.email')}
                                        value={formData.email}
                                        onChange={this.handleInputEmail}
                                        required
                                    />
                                    {errors.email && <span className="germany-section__signup-container__input--error-message">{errors.email}</span>}
                                </div>
                            </div>
                        </div>
                        <button className="bahag-orange-button" onClick={this.handleContinue}>
                            {translate('bahag.signup.continue.button')}
                        </button>
                    </form>

                    <span className="germany-section__separator-line"></span>
                    <button className="bahag-gray-button" onClick={() => this.props.showBahagSignIn()}>
                        {translate('bahag.signup.back.to.signin.button')}
                    </button>
                </div>
            </>
        );
    }

    handleInputChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
        }));

        if (value.trim() !== "") {
            this.setState((prevState) => ({
                errors: {
                    ...prevState.errors,
                    [name]: "",
                },
            }));
        }
    }

    handleInputPhone(event) {
        const name = event.target.name;
        const value = event.target.value;

        const phonePattern = /^( )*(0|\+)([0-9]| |[\+\-\(\)\/])*$/;

        // Check if the phone number matches the pattern
        this.setState((prevState) => ({
            errors: {
                ...prevState.errors,
                [name]: !phonePattern.test(value) ? "Invalid phone number format." : "",
            },
        }));

        this.updateFormData(name, value)
    }

    handleInputEmail(event) {
        const name = event.target.name;
        const value = event.target.value;

        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Check if the email matches the pattern
        this.setState((prevState) => ({
            errors: {
                ...prevState.errors,
                [name]: !emailPattern.test(value) ? "Invalid email format." : "",
            },
        }));

        this.updateFormData(name, value)
    }

    updateFormData(name, value) {
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
        }));
    }

    validateField() {
        this.setState({ errors: {} })
        const { errors, formData } = this.state;

        for (const fieldName in formData) {
            errors[fieldName] = formData[fieldName].trim() === "" ? "This field is required." : "";
        }
        this.setState({ errors });
    }

    renderPasswordRegistration() {
        const { errors, formData } = this.state;

        return (
            <>
                <h3 id="bahag-signin" className="checkout__section-title">{translate('checkout.bahag.signin.header')}</h3>
                <div className="germany-section__signup-container">
                    <div className="germany-section__password-container--top">
                        <span></span>
                        <p className="germany-section__password-container--top--title">{translate("checkout.bahag.signup.title")}</p>
                        <p className="germany-section__password-container--top--description">{translate("checkout.bahag.signup.description")}</p>

                        {this.state.isShowValidationErrorMessage && !this.state.isShowPasswordErrorMessage &&
                            <div className="germany-section__password-container--top--error-message">
                                <p>{this.state.errorMessage}</p>
                            </div>
                        }

                        {this.state.isShowEmailErrorMessage &&
                            <div className="germany-section__password-container--top--error-message">
                                <p>{this.state.emailErrorMessage}</p>
                            </div>
                        }

                        {this.state.isShowPasswordErrorMessage && (
                            <div className="germany-section__password-container--top--password-fail">
                                <p>{this.state.errorMessage}</p>
                            </div>
                        )}
                    </div>
                    <div className="germany-section__password-container--input">
                        <input
                            type="password"
                            name="password"
                            placeholder={translate("checkout.bahag.placeholder.password")}
                            value={formData.password}
                            required
                            onChange={this.handleUpdatePasswordChange}
                        />
                        <input
                            type="password"
                            name="confirmPassword"
                            placeholder={translate("checkout.bahag.placeholder.confirm.password")}
                            value={formData.confirmPassword}
                            required
                            onChange={this.handleUpdatePasswordChange}
                        />

                        <button className="bahag-orange-button" onClick={this.handlePasswordSubmit}>{translate("checkout.bahag.create.account.button")}</button>
                        <button className="bahag-gray-button" onClick={this.handleEditInfo}>
                            {translate('bahag.signup.back.to.signup.button')}
                        </button>
                    </div>
                </div>
                <BahagTerms />
            </>
        );
    }

    handleEditInfo(event) {
        event.preventDefault();
        this.props.showBahagSignUp();
        this.setState({
            isShowPasswordForm: false,
            isShowSignupForm: true,
        });
        this.setState({ isShowValidationErrorMessage: false, isShowPasswordErrorMessage: false, isShowEmailErrorMessage: false, errorMessage: "", emailErrorMessage: "" });
    }

    async handleContinue(event) {
        event.preventDefault();
        const { formData } = this.state;
        this.setState({ isShowValidationErrorMessage: false, errorMessage: "" });
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
        let validationPassed = true;
        this.props.setSignUpForm(formData);
        this.validateField();

        //Validation
        if (formData.firstname && (formData.firstname.length < 2 || formData.firstname.length > 34)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.firstname.length") });
            validationPassed = false;
        }
        else if (formData.lastname && (formData.lastname.length < 2 || formData.lastname.length > 35)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.lastname.length") });
            validationPassed = false;
        }
        else if (formData.address && (formData.address.length < 2 || formData.address.length > 2147483647)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.address.length") });
            validationPassed = false;
        }
        else if (formData.city && (formData.city.length < 2 || formData.city.length > 35)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.city.length") });
            validationPassed = false;
        }
        else if (formData.houseNumber && (formData.houseNumber.length > 15 || !/\d/.test(formData.houseNumber))) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.housenumber.form") });
            validationPassed = false;
        }
        else if (formData.phone && !/( )*(0|\+)([0-9]| |[\+\-()/])*/.test(formData.phone)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.phone.form") });
            validationPassed = false;
        } else if (
            formData.firstname &&
            formData.lastname &&
            formData.address &&
            formData.zipCode &&
            formData.city &&
            formData.email.match(emailRegex) &&
            formData.houseNumber &&
            validationPassed
        ) {

            const city = formData.city.trim();
            const isGermanCity = this.state.germanCities.some(germanCity => {
                return germanCity.toLowerCase() === city.toLowerCase();
            });

            if (!isGermanCity) {
                this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.not.germany") });
                validationPassed = false;
            } else {
                this.setState({
                    isShowPasswordForm: true,
                    isShowSignupForm: false,
                });
            }
        }
    }

    handleUpdatePasswordChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                [name]: value,
            },
        }));
    }

    async handlePasswordSubmit() {
        const { formData } = this.state;
        this.setState({ isShowValidationErrorMessage: false, isShowPasswordErrorMessage: false, isShowEmailErrorMessage: false, errorMessage: "", emailErrorMessage: "" });
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).{8,100}$/;
        const { password, confirmPassword } = this.state.formData;
        if (!passwordRegex.test(password) || !passwordRegex.test(confirmPassword) || password === "" || confirmPassword === "") {
            this.setState({ isShowPasswordErrorMessage: true, errorMessage: translate("checkout.bahag.password.error.message") });
            return;
        } else if (password === confirmPassword) {
            this.setState({ isShowPasswordErrorMessage: false })
            this.props.setSignUpForm(formData);
            this.handleCreateAccount();
        } else {
            this.setState({ isShowPasswordErrorMessage: true, errorMessage: translate("checkout.bahag.password.not.match.message") });
        }
    }

    async handleCreateAccount() {
        let tosAndDataPrivacyCheckBoxChecked = this.props.isTosAndDataPrivacyChecked

        if (tosAndDataPrivacyCheckBoxChecked) {
            this.setState({ isShowPasswordErrorMessage: false })
            const createNewCustomer = await this.props.createCustomer(this.state.formData);
            this.props.displayLoader(true);
            if (createNewCustomer && createNewCustomer.Data !== "Unauthorized" && createNewCustomer.Data) {
                const deserializeCustomerData = JSON.parse(createNewCustomer.Data);
                if (deserializeCustomerData) {
                    const status = deserializeCustomerData.status;

                    // If the account exist already
                    if (status === 400) {
                        if (deserializeCustomerData.title === "Validation failure") {
                            const errorCode = deserializeCustomerData.details[0].code;
                            this.props.displayLoader(false);

                            switch (errorCode) {
                                case "billingAddress":
                                    this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.postalcode.form") });
                                    break;
                                case "uid":
                                    this.setState({ isShowEmailErrorMessage: true, emailErrorMessage: translate("checkout.customer.address.form.error.message.email.form") });
                                    break;
                            }
                        }
                        else {
                            const errorMessage = deserializeCustomerData.details.errors[0].message;
                            if (errorMessage === "registrationForm.mail.invalid.duplicate") {
                                this.props.displayLoader(false);
                                this.setState({ isShowPasswordErrorMessage: true, errorMessage: translate("checkout.bahag.error.message.email.exist") });
                            }
                        }

                        // If the account is created 
                    } else if (deserializeCustomerData) {
                        const authorizationHybris = deserializeCustomerData.oauth_data.access_token;
                        this.props.setAuthorizationHybris(authorizationHybris);
                        setCookie("authorizationHybris", authorizationHybris, 20);
                        this.props.displayLoader(false);
                    }
                }
            } else {
                this.props.setActiveBahagErrorModal(true);
                this.props.displayLoader(false);
            }
        } else {
            this.setState({ isShowPasswordErrorMessage: true, errorMessage: translate("checkout.bahag.signup.error.message.checkbox") })
        }
    }

    render() {
        return (
            <div>
                {this.state.isShowSignupForm && this.renderSignup()}
                {this.state.isShowPasswordForm && this.renderPasswordRegistration()}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    createCustomer: (info) => dispatch(createCustomer(info)),
    showBahagSignIn: () => dispatch(showBahagSignIn(true)),
    showBahagSignUp: () => dispatch(showBahagSignUp(true)),
    showBahagForgetPassword: () => dispatch(showBahagForgetPassword(true)),
    showConfirmLogin: () => dispatch(showConfirmLogin(true)),
    setActiveBahagErrorModal: (isActive) => dispatch(setActiveBahagErrorModal(isActive)),
    setAuthorizationHybris: (authorizationHybris) => dispatch(setAuthorizationHybris(authorizationHybris)),
    displayLoader: (isLoaderActive) => dispatch(displayLoader(isLoaderActive)),
    setSignUpForm: (form) => dispatch(setSignUpForm(form))
});

const mapStateToProps = state => {
    return {
        isTosAndDataPrivacyChecked: state.bahag.isTosAndDataPrivacyChecked,
        customerInfo: state.bahag.customerInfo,
        signUpForm: state.bahag.signUpForm
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(BahagSignUp);